import { render, staticRenderFns } from "./wordleInstruction.vue?vue&type=template&id=7c9018bc"
import script from "./wordleInstruction.vue?vue&type=script&lang=js"
export * from "./wordleInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports